import { Tag } from 'antd'

type Props = {
  status: string
}

export const CSLBContractorStatusDisplay = ({ status }: Props) => {
  return <Tag color={status === 'CLEAR' ? 'green' : 'red'}>{status}</Tag>
}
